module.exports = __webpack_public_path__ + "static/media/rekit-react.5c11e8db.png";